// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"TextBlock_textBlock__NbNaS"};